import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAnalytics() {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const key = location.pathname + location.search;
    if (key === lastTracked.current) return;
    lastTracked.current = key;

    const data = {
      event_type: 'page_view',
      page: location.pathname,
      referrer: document.referrer || '',
      user_agent: navigator.userAgent || '',
    };

    axios.post(`${API}/analytics/track`, data).catch(() => {});
  }, [location.pathname, location.search]);
}

export function trackArtworkView(artworkId, artworkTitle) {
  const data = {
    event_type: 'artwork_view',
    page: window.location.pathname,
    artwork_id: artworkId,
    artwork_title: artworkTitle,
    referrer: document.referrer || '',
    user_agent: navigator.userAgent || '',
  };
  axios.post(`${API}/analytics/track`, data).catch(() => {});
}

export function trackCartAdd(artworkId, artworkTitle) {
  const data = {
    event_type: 'cart_add',
    page: window.location.pathname,
    artwork_id: artworkId,
    artwork_title: artworkTitle,
    referrer: document.referrer || '',
    user_agent: navigator.userAgent || '',
  };
  axios.post(`${API}/analytics/track`, data).catch(() => {});
}

export function trackPurchase() {
  const data = {
    event_type: 'purchase',
    page: window.location.pathname,
    referrer: document.referrer || '',
    user_agent: navigator.userAgent || '',
  };
  axios.post(`${API}/analytics/track`, data).catch(() => {});
}
